import { QueryKeys } from '../../utils/queryKeys';

export const certificateKeys = {
    all: [QueryKeys.CERTIFICATE_KEYS],
    getAllCertificate: () => [...certificateKeys.all],
};